export default function initSearchForms(state) {
    initSearchFormSelection();

    // Postavlja labele(placeholdere) nekih elemenata formi
    $('#lighthouseSearchForm_region option[value=""]').text(state.lighthouseSearchFormRegionLabel);
    $('#lighthouseSearchForm_persons option[value=""]').text(state.lighthouseSearchFormPersonsLabel);
    $('#charterSearchForm_port option[value=""]').text(state.charterSearchFormPortLabel);
    $('#charterSearchForm_persons option[value=""]').text(state.charterSearchFormPersonsLabel);
}

/**
 * Omogućava selektiranje ikone i prikaz željene forme.
 */
function initSearchFormSelection() {
    const searchForms = document.querySelectorAll('#chooseAccommodation li');
    searchForms.forEach((elem) => {
        elem.addEventListener('click', (e) => {
            const activeForm = document.querySelector('#chooseAccommodation li.active');
            if (activeForm !== null) {
                // Deselektira ikonu i skriva aktivnu formu
                activeForm.classList.remove('active');
                document.getElementById(activeForm.getAttribute('data-form-id')).classList.add('hidden');

                // Selektira kliknutu ikonu i prikazuje pripadajuću formu
                e.target.classList.add('active');
                document.getElementById(e.target.getAttribute('data-form-id')).classList.remove('hidden');
            }
        });
    });
}
